import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { FixedSizeList } from "react-window";
import cn from "../../../../utils/cn";
import DropdownBodyPlaceholder from "../DropdownBodyPlaceholder";
const DropdownList = ({ heightList = 300, heightItem = 24, data, isLoading = false, className, loadingComponent: Loading, placeholderComponent: Placeholder, itemComponent: ItemList, }) => {
    const itemCount = data?.length;
    if (isLoading)
        return _jsx(_Fragment, { children: Loading || "Carregando..." });
    if (!itemCount)
        return Placeholder ? _jsx(_Fragment, { children: Placeholder }) : _jsx(DropdownBodyPlaceholder, {});
    const Row = ({ index, style }) => {
        const item = data[index];
        return _jsx("div", { style: style, children: ItemList(item, index) });
    };
    return (_jsx(FixedSizeList, { className: cn("scrollBar", className), itemCount: itemCount, height: heightList, itemSize: heightItem, width: "100% z-10", children: Row }));
};
export default DropdownList;
